import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, orientation = 'horizontal', ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    orientation={orientation}
    className={cn(
      orientation === 'vertical'
        ? 'relative flex h-full min-h-[3rem] w-5 touch-none select-none flex-col items-center justify-center'
        : 'relative flex w-full touch-none select-none items-center',
      className,
    )}
    {...props}>
    <SliderPrimitive.Track
      className={cn(
        'relative overflow-hidden rounded-full bg-primary/20',
        orientation === 'vertical' ? 'h-full w-1.5 grow' : 'h-1.5 w-full grow',
      )}>
      <SliderPrimitive.Range
        className={cn(
          'absolute bg-primary',
          orientation === 'vertical' ? 'w-full' : 'h-full',
        )} />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      className="block h-4 w-4 rounded-full border border-primary/50 bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
